/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ProvisioningDeviceByDeviceTypeResponse,
    ProvisioningDeviceByDeviceTypeResponseFromJSON,
    ProvisioningDeviceByDeviceTypeResponseFromJSONTyped,
    ProvisioningDeviceByDeviceTypeResponseToJSON,
} from './ProvisioningDeviceByDeviceTypeResponse';

/**
 * 
 * @export
 * @interface ProvisioningDevicesByDeviceTypeResponse
 */
export interface ProvisioningDevicesByDeviceTypeResponse {
    /**
     * 
     * @type {Array<ProvisioningDeviceByDeviceTypeResponse>}
     * @memberof ProvisioningDevicesByDeviceTypeResponse
     */
    provisioningDevices?: Array<ProvisioningDeviceByDeviceTypeResponse>;
    /**
     * 
     * @type {number}
     * @memberof ProvisioningDevicesByDeviceTypeResponse
     */
    count?: number;
}

export function ProvisioningDevicesByDeviceTypeResponseFromJSON(json: any): ProvisioningDevicesByDeviceTypeResponse {
    return ProvisioningDevicesByDeviceTypeResponseFromJSONTyped(json, false);
}

export function ProvisioningDevicesByDeviceTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProvisioningDevicesByDeviceTypeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'provisioningDevices': !exists(json, 'provisioningDevices') ? undefined : ((json['provisioningDevices'] as Array<any>).map(ProvisioningDeviceByDeviceTypeResponseFromJSON)),
        'count': !exists(json, 'count') ? undefined : json['count'],
    };
}

export function ProvisioningDevicesByDeviceTypeResponseToJSON(value?: ProvisioningDevicesByDeviceTypeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'provisioningDevices': value.provisioningDevices === undefined ? undefined : ((value.provisioningDevices as Array<any>).map(ProvisioningDeviceByDeviceTypeResponseToJSON)),
        'count': value.count,
    };
}

